<template>
  <section v-show="showComponent">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="chooseVehicle" slot-scope="prop" class="choose-flex">
        <ChooseVehicle
          style="display: inline-block"
          :isRadio="true"
          :disabled="prop.item.disabled"
          v-model="prop.form.chooseVehicle"
          @change="vehicleChange"
        />
        <span style="margin-left: 16px" v-if="prop.form.chooseVehicle">
          {{ prop.form.chooseVehicle.vehicleClassName
          }}{{
          prop.form.chooseVehicle.vehicleStatusName
          ? '/' + prop.form.chooseVehicle.vehicleStatusName
          : ''
          }}{{
          prop.form.chooseVehicle.vehicleLengthName
          ? '/' + prop.form.chooseVehicle.vehicleLengthName
          : ''
          }}{{
          prop.form.chooseVehicle.licenceType == 2 ? '/牵引车' : ''
          }}
        </span>
      </section>
      <section slot="chooseTrailer" slot-scope="prop" class="choose-flex">
        <el-select v-model="prop.form.chooseTrailer" filterable :filter-method="searchTrailer" placeholder="请选择">
          <el-option
              v-for="item in trailerOptions"
              :key="item.trailerId"
              :label="item.trailerNumber"
              :value="item.trailerId"
              @click.native="selectTrailer(item.trailerId,item)"
          >
          </el-option>
        </el-select>
        <span style="margin-left: 16px" v-if="prop.form.chooseTrailer">
        {{otherFormData.dispatchTrailerInfo.trailerType}}
        </span>
      </section>
      <section slot="chooseDriver" slot-scope="prop" class="choose-flex">
        <ChooseDriver
          style="display: inline-block"
          :isRadio="true"
          :disabled="prop.item.disabled"
          v-model="prop.form.chooseDriver"
          @change="chooseDriverChange"
          :fnRadioDisabled="
            (item) => {
              return item.state !== 2 || item.entryState===2;
            }
          "
        />
        <span
          style="margin-left: 16px"
          v-if="prop.form.chooseDriver && prop.form.chooseDriver.loginAcct"
        >{{ prop.form.chooseDriver.loginAcct }}</span>
      </section>
      <section slot="chooseCopilotDriver" slot-scope="prop">
        <ChooseDriver
          style="display: inline-block"
          :isRadio="true"
          :disabled="prop.item.disabled"
          v-model="prop.form.chooseCopilotDriver"
          @change="chooseCopilotDriverChange"
          :fnRadioDisabled="
            (item) => {
              return item.state !== 2 || item.entryState===2;
            }
          "
        />
        <span
          style="margin-left: 16px"
          v-if="
            prop.form.chooseCopilotDriver &&
            prop.form.chooseCopilotDriver.loginAcct
          "
        >{{ prop.form.chooseCopilotDriver.loginAcct }}</span>
      </section>
      <section slot="paymentWaySwitch" slot-scope="prop">
        <Reimbursement
          ref="reimbursement"
          :driverOilForPayWay="otherFormData.driverOilForPayWay"
          :receiverUserInfo="otherFormData.receiverUserInfo"
          v-show="isPaymentWay(prop.form.paymentWay, '2')"
        />
        <Contract
          ref="contract"
          :chartData="otherFormData"
          :paymentWay="Number(prop.form.paymentWay)"
          :appointWay="3"
          v-show="isPaymentWay(prop.form.paymentWay, '3')"
        />
        <Orderment
            ref="orderment"
            :orderData="expenseTypeList"
            v-show="isPaymentWay(prop.form.paymentWay, '4')"
        />
        <Intelligence
          ref="intelligence"
          :chartData="otherFormData"
          :paymentWay="Number(prop.form.paymentWay)"
          :appointWay="3"
          :getFeeParams="getFeeParams"
          @onRunWayChange="onRunWayChange"
          v-show="isPaymentWay(prop.form.paymentWay, '1')"
        />
      </section>
      <section slot="otherVehicleContractChart" slot-scope="prop">
        <Contract
          ref="contract"
          :chartData="otherFormData"
          :paymentWay="Number(prop.form.paymentWay)"
          :appointWay="3"
          v-show="!isSelfOwnedVehicle(prop.form.chooseVehicle)"
        />
        <!-- @checkOilAccount="checkOilAccount" -->
      </section>
    </qx-custom-form>
    <button @click="getDataTest" class="test-btn">指派车辆提交参数</button>
  </section>
</template>

<script>
import {
  getAccountInfo,
  trailerInfo,
  getVirtualTenantList,
  getVehicleDataInfo,
  checkServiceBill,
  getDriverOil,
  getDriverOilForPayWay,
  checkPayMentWaySwitchover, getOperInteCfgResultInfo,
} from 'api/operate';
import ChooseVehicle from 'components/choose/vehicle';
import ChooseDriver from 'components/choose/driver';
import Reimbursement from './paymentWay/reimbursement/reimbursement';
import Orderment from './paymentWay/orderment/orderment';
import Contract from '../components/contract';
import Intelligence from './paymentWay/intelligence/intelligence';
import {
  isExist,
} from '@qx/utils/index';
// import { checkDriverInfo } from './checkInfo';
export default {
  components: {
    ChooseVehicle,
    ChooseDriver,
    Reimbursement,
    Orderment,
    Contract,
    Intelligence,
  },
  props: {
    modeOtherData: {
      type: Object,
      default: () => ({}),
    },
    showComponent: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      isEnum: null, // 判断成本模式的表单是根据运营端个性化配置返回还是枚举值查询接口返回
      isExist: null, // 判断个性化配置是否配置订单模式
      paymentWayList: [],
      trailerOptions: [],
      defaultBillData: {},
      // 订单模式出车打款金额明细
      expenseTypeList: [],
      // 计算费率需要用的参数
      getFeeParams: {
        vehicleCode: '',
        plateNumber: '',
        carDriverId: '',
        copilotUserId: '',
        trailerId: '',
        dependTime: '',
        lineId: '',
        arriveTime: '',
        loadEmptyOilCost: '',
        loadFullOilCost: '',
        pontagePer: '',
        distance: '',
        nand: '',
        eand: '',
        desEand: '',
        desNand: '',
        region: '',
        provinceId: '',
        isUpdate: false,
        emptyDistance: 0,
        oilPrice: '',
      },
      otherFormData: {
        lineInfo: {},
        oilInfo: {},
        // 代理人相关信息
        receiverUserInfo: {},
        // 挂车相关信息
        dispatchTrailerInfo: {},
        // 已选择的车辆信息
        selectedCarInfo: {},
        // 油卡余额
        sPreOilBalance: '',
        // 当前油卡充值的金额
        sInputOilBalance: '',
        // 上次油卡充值的金额
        sBeforeBalance: 0,
        // 油卡列表
        oilcardList: [],
        driverOilForPayWay: {},
        // 当前选择车辆所属车队租户
        selectedVehicleTenantId: '',
        // 上一次选择的成本模式
        prePaymentWay: '',
        dependTimeFromBaseForm: '',
      },
      baseForm: {
        paymentWayOptions: [],
        form: [
          {
            label: '选择车辆',
            value: 'chooseVehicle',
            default: {},
            slot: true,
            hide: false,
            disabled: false,
            placeholder: '请选择车牌',
          },
          // 挂车信息（如果是牵引车，要输入挂车车牌）
          {
            label: '挂车车牌',
            value: 'chooseTrailer',
            // type: 'el-autocomplete',
            // valueKey: 'trailerNumber',
            disabled: false,
            slot: true,
            hide: true,
            // querySearchAsync: (queryString, cb) => {
            //   let resTrailer = [];
            //   if (queryString && queryString.length) {
            //     trailerInfo({ trailerNumber: queryString }).then((res) => {
            //       if (res && res.items) {
            //         resTrailer = res.items;
            //       }
            //       cb(resTrailer);
            //     });
            //   }
            //   cb(resTrailer);
            // },
            // onSelect: (item) => {
            //   this.otherFormData.dispatchTrailerInfo = item;
            //   this.getFee({
            //     trailerId: item.trailerId,
            //   });
            // },
          },
          {
            label: '主驾信息',
            value: 'chooseDriver',
            default: {},
            slot: true,
            hide: true,
            disabled: false,
          },
          {
            label: '副驾信息',
            value: 'chooseCopilotDriver',
            default: {},
            slot: true,
            hide: true,
            disabled: false,
          },
          {
            label: '成本模式',
            value: 'paymentWay',
            type: 'radio',
            hide: true,
            disabled: false,
            onChange: (paymentWay) => {
              const driverInfo = this.$refs.baseForm.getVal('chooseDriver') || {};
              if (!driverInfo.userId) {
                this.$message({
                  type: 'info',
                  message: '请选择主驾',
                });
                this.$refs.baseForm.setVal('paymentWay', '');
              } else {
                // 显示对应的内容
                this.paymentWayChange(paymentWay, false, true);
              }
            },
          },
          {
            label: '是否代收',
            value: 'isAgent',
            type: 'select',
            default: false,
            hide: true,
            options: [
              { label: '是', value: true },
              { label: '否', value: false },
            ],
            onChange: (val) => {
              this.isAgentChange(val);
            },
          },
          {
            label: '代理人id',
            value: 'agentId',
            type: 'input',
            default: 0,
            readonly: true,
            hide: true,
          },
          {
            label: '收款人手机',
            value: 'agentPhone',
            type: 'el-autocomplete',
            valueKey: 'mobilePhone',
            hide: true,
            querySearchAsync: this.querySearchAsync,
            onSelect: (item) => this.querySearchOnSelect(item),
          },
          {
            label: '收款人',
            value: 'agentAccountName',
            type: 'el-autocomplete',
            valueKey: 'linkman',
            hide: true,
            querySearchAsync: this.querySearchAsync,
            onSelect: (item) => this.querySearchOnSelect(item),
          },
          {
            value: 'paymentWaySwitch',
            allCustom: true,
            hide: true,
          },
          {
            value: 'otherVehicleContractChart',
            allCustom: true,
            hide: true,
          },
        ],
        rules: {
          chooseVehicle: [
            { required: true, message: '请选择车辆', trigger: 'change' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请选择车辆'),
              trigger: 'blur',
            },
          ],
          chooseTrailer: [
            { required: true, message: '请输入挂车信息', trigger: 'blur' },
            // {
            //   validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请输入挂车信息'),
            //   trigger: 'blur',
            // },
          ],
          chooseDriver: [
            { required: true, message: '请选择主驾', trigger: 'change' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请选择主驾'),
              trigger: 'blur',
            },
          ],
          paymentWay: [
            { required: true, message: '请选择成本模式', trigger: 'blur' },
            {
              validator: (rule, value, callback) => this.checkObjEmpty(rule, value, callback, '请选择成本模式'),
              trigger: 'blur',
            },
          ],
        },
      },
    };
  },
  methods: {
    searchTrailer (val) {
      let resTrailer = [];
      if (val) {
        trailerInfo({ trailerNumber: val }).then((res) => {
          resTrailer = Array.isArray(res) ? res : (Array.isArray(res && res.items) ? res.items : []);
          this.trailerOptions = resTrailer;
        });
      } else {
        this.trailerOptions = [];
      }
    },
    selectTrailer (trailerId, item) {
      this.otherFormData.dispatchTrailerInfo = item;
      this.getFee({
        trailerId: trailerId,
      });
    },
    setList (options, otherData, isEnum) {
      this.baseForm.paymentWayOptions = options;
      this.isEnum = isEnum;
      this.defaultBillData = otherData.defaultBillData;
    },
    getFee (changeData) {
      this.setFormValFromData(this.getFeeParams, changeData);
      const paymentWay = this.$refs.baseForm.getVal('paymentWay');
      if (`${paymentWay}` === '1') {
        setTimeout(() => {
          this.$refs.intelligence.getFee(this.getFeeParams);
        }, 100);
      }
    },
    onRunWayChange (data) {
      this.getFee({
        emptyDistance: data,
      });
    },
    setDependTime (data) {
      this.getFee({
        dependTime: data,
      });
    },
    setOrdermentLineData () {
      if (!this.$refs.orderment || !this.otherFormData.lineInfo) {
        return;
      }
      this.$refs.orderment.setLineData({
        fullFreight: this.otherFormData.lineInfo.fullFreight,
        projectSettlementPrice: this.otherFormData.lineInfo.projectSettlementPrice,
      });
    },
    setData (data) {

      this.otherFormData.lineInfo = data.lineInfo;
      this.otherFormData.oilInfo = data.oilInfo;

      if (data.lineInfo) {

        let arriveTime = isExist(data.lineInfo.arriveTime) ? Number(data.lineInfo.arriveTime) : 0;

        if (isExist(data.lineInfo.subWayList)) {
          for (var i = 0; i < data.lineInfo.subWayList.length; i++) {
            if (isExist(data.lineInfo.subWayList[i].arriveTime)) {
              arriveTime += Number(data.lineInfo.subWayList[i].arriveTime);
            }
          }
        }

        this.getFee({
          lineId: data.lineInfo.lineId,
          arriveTime,
          loadEmptyOilCost: data.lineInfo.emptyOilCostPer,
          loadFullOilCost: data.lineInfo.oilCostPer,
          pontagePer: data.lineInfo.pontagePer,
          distance: data.lineInfo.mileageNumber * 1000,
          region: data.lineInfo.sourceCityName,
          provinceId: data.lineInfo.sourceProvince,
          nand: data.lineInfo.sourceNand,
          eand: data.lineInfo.sourceEand,
          desEand: data.lineInfo.desEand,
          desNand: data.lineInfo.desNand,
        });

        this.$nextTick(() => {
          if (this.$refs.orderment) {
            this.setOrdermentLineData();
          }
          if (this.$refs.intelligence) {
            this.$refs.intelligence.setFormData({
              emptyOilCostPer: this.otherFormData.lineInfo.emptyOilCostPer / 100,
              oilCostPer: this.otherFormData.lineInfo.oilCostPer / 100,
              pontagePer: this.otherFormData.lineInfo.pontagePer / 100,
            });
          }
        });
      }
    },
    // 输入关键字来查询相关信息
    querySearchAsync (queryString, cb) {
      let resList = [];
      if (queryString && queryString.length) {
        getVirtualTenantList({
          name: queryString,
          includeDriver: false,
        }).then((res) => {
          if (res && res.items) {
            resList = res.items;
          }
          cb(resList);
        });
      }
      cb(resList);
    },
    // 点击选择其中一项
    querySearchOnSelect (item) {
      this.otherFormData.receiverUserInfo = item;
      this.$refs.baseForm.setVal('agentPhone', item.mobilePhone);
      this.$refs.baseForm.setVal('agentAccountName', item.linkman);
      this.$refs.baseForm.setVal('agentId', item.userId);
    },
    isPaymentWay (value, paymentWay) {
      return `${value}` === `${paymentWay}`;
    },
    isSelfOwnedVehicle (selectedCarInfo = {}) {
      return `${selectedCarInfo.vehicleClass}` === '1';
    },
    async refreshVehiclePaymentWayOptions () {
      const tenantId = this.otherFormData.selectedVehicleTenantId;
      if (!tenantId) {
        return;
      }
      const paymentWayOptions = await getOperInteCfgResultInfo({
        busiCode: '10010201',
        filedName: '成本模式',
        tenantId,
      });
      if (paymentWayOptions.length > 0) {
        this.baseForm.paymentWayOptions = paymentWayOptions;
        this.isEnum = false;
      }
    },
    // 修改车辆
    async vehicleChange (selectedCarInfo) {
      // 个性化字段配置属于车辆所在车队。先解析车队租户，再进入订单模式加载配置，
      // 避免 paymentWayChange 以空 tenantId 提前查询并回退到当前登录租户。
      this.otherFormData.selectedVehicleTenantId = selectedCarInfo.tenantId || '';
      const resVehicleInfo = await this.setVehicleByChange(selectedCarInfo);
      await this.refreshVehiclePaymentWayOptions();
      await this.setFormItemShowAndHide(selectedCarInfo);
      // paymentWaySwitch 是 qx-custom-form 的条件插槽；显示后要等一轮渲染才能取得 reimbursement ref。
      await this.$nextTick();
      if (this.isSelfOwnedVehicle(selectedCarInfo) && resVehicleInfo && this.$refs.reimbursement) {
        this.getEmptyOilCostPerAndOilCostPer(resVehicleInfo);
      }
    },
    // 点击【选择车辆】,设置表单的显示隐藏
    async setFormItemShowAndHide (selectedCarInfo) {
      if (!selectedCarInfo.plateNumber) {
        return;
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
      });
      // 重置下面的所有表单数据
      let names = ['chooseVehicle'];
      if (this.isSelfOwnedVehicle(selectedCarInfo)) {

        const isExist = this.baseForm.paymentWayOptions.some((item) => { // 判断有订单模式时，表单参数取个性化配置的
          if (`${item.value}` === '4') {
            return true;
          }
        });
        this.isExist = isExist;
        if (isExist) {
          this.$refs.baseForm.setVal('paymentWay', '4');
          this.paymentWayChange('4');
        } else {
          this.$refs.baseForm.setVal('paymentWay', '');
        }

        // 自有车
        if (selectedCarInfo.licenceType === 2) {
          // 如果是牵引车，要输入挂车车牌
          names.push('chooseTrailer');
        }
        // 自有车需要展示的字段有：主驾，副驾，成本模式，以及成本模式下面的各种内容
        names.push('chooseDriver', 'chooseCopilotDriver', 'paymentWay', 'paymentWaySwitch');

      } else {
        this.$refs.baseForm.setVal('paymentWay', '');
        // 非自有车需要展示的字段有：主驾，是否代收，以及图表
        names.push('chooseDriver', 'isAgent', 'otherVehicleContractChart');
        this.$nextTick(() => {
          // 图表需要计算各种费用
          this.$refs.contract.getVehicleClassLevel(selectedCarInfo.vehicleClass, 'setVehicleInfo');
        });
        // 点击是否代收，会出现 收款手机 和 收款人
        const isAgent = this.$refs.baseForm.getVal('isAgent');
        this.isAgentChange(!!isAgent);
      }
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names,
      });
    },
    // 从缓存和详情中获取数据填入
    async setVehicleInfoFromCacheAndDetail (data) {
      const selectedCarInfo = data.chooseVehicle;
      if (selectedCarInfo.plateNumber) {
        // 校验车辆是否缴费
        const resServiceBillInfo = await checkServiceBill({
          plateNumber: selectedCarInfo.plateNumber,
        });
        if (resServiceBillInfo === 'Y') {
          if (this.isSelfOwnedVehicle(selectedCarInfo)) {
            // paymentWaySwitch 可能刚从隐藏切换为显示，等待 reimbursement 组件完成渲染。
            await this.$nextTick();
            if (this.$refs.reimbursement) {
              this.$refs.reimbursement.setEmptyOilCostPerAndOilCostPer({
                emptyOilCostPer: data.emptyOilCostPer,
                oilCostPer: data.oilCostPer,
              });
            }
          }
          this.queryMemberBenefits(selectedCarInfo.vehicleClass, false);
        }
      }
    },
    // 修改车牌号，如果有主驾司机也顺便把主驾司机修改掉
    async setVehicleByChange (selectedCarInfo) {
      // 校验车辆是否缴费，没缴费就不用往下走了
      const resServiceBillInfo = await checkServiceBill({
        plateNumber: selectedCarInfo.plateNumber,
      });
      if (resServiceBillInfo === 'Y') {
        const resVehicleInfoList = await getVehicleDataInfo({
          '_GRID_TYPE': 'jq',
          'page': 1,
          'rows': 10,
          plateNumber: selectedCarInfo.plateNumber,
        });
        // 如果查询车辆信息里面绑定了一个司机，需要自动填充该司机到 主驾 字段上面
        let resVehicleInfo = {};
        if (resVehicleInfoList && resVehicleInfoList.rows && resVehicleInfoList.rows.length) {
          resVehicleInfo = resVehicleInfoList.rows[0];
        }
        let driverData = this.$refs.baseForm.getVal('chooseDriver');
        if (resVehicleInfo.userId) {
          driverData = {
            linkman: resVehicleInfo.carOwner || '',
            loginAcct: resVehicleInfo.carPhone || '',
            userId: resVehicleInfo.userId || '',
          };
        }
        this.$refs.baseForm.setVal('chooseDriver', driverData);

        if (this.isSelfOwnedVehicle(selectedCarInfo)) {
          this.otherFormData.selectedVehicleTenantId = resVehicleInfo.tenantId || selectedCarInfo.tenantId || '';
          this.getAccountInfo(resVehicleInfo.tenantId);
          this.getFee({
            vehicleCode: selectedCarInfo.vehicleCode,
            plateNumber: selectedCarInfo.plateNumber,
            carDriverId: driverData.userId,
          });
        }
        this.queryMemberBenefits(selectedCarInfo.vehicleClass, true);
        return resVehicleInfo;
      }
      return null;
    },
    // 获取车队账户信息
    async getAccountInfo (tenantId) {
      const resAccount = await getAccountInfo({ tenantId });
      if (!resAccount.failed) {
        // console.log(resAccount);
      }
    },
    // 【成本模式】切换
    async paymentWayChange (paymentWay, isGetFee, fromUserChange = false) {
      if (!paymentWay) {
        return;
      }
      paymentWay = `${paymentWay}`;
      let paymentWayList = [];
      // 订单模式字段是“成本模式”的下一层配置。当前模式为4时必须直接查询，
      // 不能依赖父级列表是否被成功解析，否则只会发出 filedName=成本模式 的第一次请求。
      if (paymentWay === '4') {
        const selectedPaymentWay = this.baseForm.paymentWayOptions.filter((item) => `${item.value}` === paymentWay)[0] || {};
        paymentWayList = await getOperInteCfgResultInfo({
          busiCode: '10010201',
          filedName: selectedPaymentWay.fieldName || '订单模式',
          tenantId: this.otherFormData.selectedVehicleTenantId,
        });
        this.paymentWayList = paymentWayList;
        if (paymentWayList.length > 0) {
          this.isEnum = false;
        }
        await this.$refs.orderment.setList(paymentWayList, false, paymentWayList.length > 0);
      } else if (!this.isEnum) {
        const show = this.baseForm.paymentWayOptions.some((item) => `${item.value}` === paymentWay);
        const nextPaymentWay = show ? paymentWay : '';
        if (!fromUserChange && `${this.$refs.baseForm.getVal('paymentWay')}` !== `${nextPaymentWay}`) {
          this.$refs.baseForm.setVal('paymentWay', nextPaymentWay);
        }
      } else if (!fromUserChange && `${this.$refs.baseForm.getVal('paymentWay')}` !== `${paymentWay}`) {
        this.$refs.baseForm.setVal('paymentWay', paymentWay);
      }
      switch (paymentWay) {
        case '2':
          // 报账模式，显示报账模式的表单
          this.getOilAccountBalanceAndOther();
          break;
        case '3':
          // 承包模式，显示承包模式表单
          // if (this.checkPayMentWaySwitchover()) {
          this.$nextTick(() => {
            const chooseVehicle = this.$refs.baseForm.getVal('chooseVehicle');
            this.$refs.contract.getVehicleClassLevel(chooseVehicle.vehicleClass, 'paymentWay');
          });
          // }
          break;
        case '1':
          // 智能模式
          // if (this.checkPayMentWaySwitchover()) {
          // 设置空载油耗，载重油耗，单公里路桥
          this.$nextTick(() => {
            this.$refs.intelligence.setFormData({
              emptyOilCostPer: this.otherFormData.lineInfo.emptyOilCostPer / 100,
              oilCostPer: this.otherFormData.lineInfo.oilCostPer / 100,
              pontagePer: this.otherFormData.lineInfo.pontagePer / 100,
            });
            if (!isGetFee) {
              this.$refs.intelligence.getFee(this.getFeeParams);
            }
          });
          // }
          break;
        case '4':
          // 订单模式
          this.$nextTick(() => {
            if (!this.$refs.orderment) {
              return;
            }
            this.$refs.orderment.setList(this.paymentWayList, false, !this.isEnum);
            // queryLineList 返回的线路运费单位为分；必须等订单模式组件渲染后再回填。
            this.setOrdermentLineData();
          });
          break;
        default:
          break;
      }
      // 如果选了副驾信息，则订单模式展示副驾基本工资和收款角色表单
      if (paymentWay === '4') {
        const chooseCopilotDriver = this.$refs.baseForm.getVal('chooseCopilotDriver') || {};
        const isCopilot = !!chooseCopilotDriver.userId;
        this.$nextTick(() => {
          if (!this.$refs.orderment) {
            return;
          }
          if (this.paymentWayList.length > 0) {
            this.$refs.orderment.setList(this.paymentWayList, isCopilot);
          } else {
            this.$refs.orderment.setOrderFormItemShowAndHide(!isCopilot, ['coDriverBasealary', 'payee', 'reportingRole']);
          }
        });
      }
      this.otherFormData.prePaymentWay = paymentWay;
    },
    // 获取【空载油耗】和【载重油耗】,
    getEmptyOilCostPerAndOilCostPer (resVehicleInfo) {
      if (`${resVehicleInfo.isUseCarOilCost}` === '1') {
        // 计算空载油耗
        let emptyOilCostPer = isExist(resVehicleInfo.loadEmptyOilCost) ? (resVehicleInfo.loadEmptyOilCost / 100).toFixed(2) : 0;
        // 计算载重油耗resetMyVehicleForm
        const oilCostPer = isExist(resVehicleInfo.loadFullOilCost) ? (resVehicleInfo.loadFullOilCost / 100.0).toFixed(2) : 0;
        this.$refs.reimbursement.setEmptyOilCostPerAndOilCostPer({
          emptyOilCostPer,
          oilCostPer,
        });
      } else {
        // 使用固定线路的油耗
        this.$refs.reimbursement.setEmptyOilCostPerAndOilCostPer({
          emptyOilCostPer: this.otherFormData.oilInfo.emptyOilCostPer,
          oilCostPer: this.otherFormData.oilInfo.oilCostPer,
        });
      }
    },
    // 获取【有账户余额】和其他信息，例如【查询加油站】和【油卡】
    async getOilAccountBalanceAndOther () {
      // 主驾信息
      const driverInfo = this.$refs.baseForm.getVal('chooseDriver') || {};
      const vehicleInfo = this.$refs.baseForm.getVal('chooseVehicle' || {});
      if (driverInfo.userId) {
        const carDriverId = driverInfo.userId;
        const plateNumber = vehicleInfo.plateNumber;
        if (carDriverId && plateNumber) {
          const resDriverOil = await getDriverOil({ carDriverId });
          const resDriverOilForPayWay = await getDriverOilForPayWay({ carDriverId });
          this.otherFormData.driverOilForPayWay = resDriverOilForPayWay;
          if (!resDriverOil.failed) {
            let oilBalance = '0.00';
            if (resDriverOil.orderAccountOut && resDriverOil.orderAccountOut.totalOilBalance !== null) {
              oilBalance = resDriverOil.orderAccountOut.totalOilBalance / 100;
            }
            this.$refs.reimbursement.setOilBalance(oilBalance);
          }
        }
      }
    },
    // 切换模式的时候检测是否允许操作本模式
    async checkPayMentWaySwitchover () {
      const selectedCarInfo = this.$refs.baseForm.getVal('chooseVehicle') || {};
      const resCheckPayMentWay = await checkPayMentWaySwitchover({
        plateNumber: selectedCarInfo.plateNumber,
        dependTime: this.modeOtherData.dependTimeFromBaseForm,
      });
      if (resCheckPayMentWay.isOver !== 'Y') {
        this.$message({
          type: 'warning',
          message: '当前车辆的上一单使用了报账模式且没有上报满油，请上报满油后再切换到其他模式开单!',
        });
        this.otherFormData.prePaymentWay = '2';
        this.$refs.baseForm.setVal('paymentWay', this.otherFormData.prePaymentWay);
        this.paymentWayChange(this.otherFormData.prePaymentWay);
        return false;
      }
      return true;
    },
    // 【指派车辆】-选择自有车-选择主驾信息
    chooseDriverChange (selectedDriverInfo) {
      // checkDriverInfo({
      //   userId: selectedDriverInfo.userId,
      // });
      this.getFee({
        carDriverId: selectedDriverInfo.userId,
      });
      this.checkDriver(selectedDriverInfo, 'chooseCopilotDriver');
    },
    // 【指派车辆】-选择自有车-选择副驾信息
    chooseCopilotDriverChange (selectedDriverInfo = {}) {
      // checkDriverInfo({
      //   userId: selectedDriverInfo.userId,
      // });
      this.getFee({
        copilotUserId: selectedDriverInfo.userId,
      });
      this.checkDriver(selectedDriverInfo, 'chooseDriver');
      // 如果选了副驾信息，则订单模式展示副驾基本工资和收款角色表单；清空副驾时同步恢复单驾并隐藏副驾相关项。
      if (this.isExist) {
        const isCopilot = !!selectedDriverInfo.userId;
        this.$nextTick(() => {
          if (!this.$refs.orderment) {
            return;
          }
          if (this.paymentWayList.length > 0) {
            this.$refs.orderment.setList(this.paymentWayList, isCopilot);
          } else {
            this.$refs.orderment.setOrderFormItemShowAndHide(!isCopilot, ['coDriverBasealary', 'payee', 'reportingRole']);
            this.$refs.orderment.setDrivingType(isCopilot);
          }
        });
      }
    },
    // 检测司主副司机是否同一个人
    checkDriver (currentSelectedDriver, checkDriver) {
      if (currentSelectedDriver.state !== 2) {
        this.$message({
          type: 'error',
          message: '该司机未认证！',
        });
        return;
      }
      const driverInfo = this.$refs.baseForm.getVal(checkDriver);
      if (driverInfo && driverInfo.userId) {
        if (`${currentSelectedDriver.userId}` === `${driverInfo.userId}`) {
          this.$message({
            type: 'error',
            message: '主驾和副驾不能选同一个人！',
          });
        }
      }
    },
    isAgentChange (val) {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: !val,
        names: ['agentPhone', 'agentAccountName'],
      });
    },
    // 设置【空载油耗】和【载重油耗】
    setEmptyOilCostPerAndOilCostPer (options = {}) {
      this.$refs.baseForm.setVal('emptyOilCostPer', options.emptyOilCostPer || '0');
      this.$refs.baseForm.setVal('oilCostPer', options.oilCostPer || '0');
    },
    // 重置【选择车辆】之后的表单数据（更换车辆的时候调用）
    resetMyVehicleForm () {
      // // 清空成本模式选择
      this.$refs.baseForm.setVal('chooseVehicle', {});
      this.$refs.baseForm.setVal('chooseCopilotDriver', {});
      this.$refs.baseForm.setVal('chooseTrailer', {});
      this.$refs.baseForm.setVal('paymentWay', '');
      // 所有表单元素隐藏
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: true,
      });
      // 只显示选择车辆
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'hide',
        value: false,
        names: ['chooseVehicle'],
      });
      // 清空空载油耗和载重油耗
      this.setEmptyOilCostPerAndOilCostPer({
        emptyOilCostPer: 0,
        oilCostPer: 0,
      });
      // 清空油账户相关信息
      this.otherFormData.sPreOilBalance = '';
      this.otherFormData.sInputOilBalance = '';
      this.otherFormData.sBeforeBalance = 0;
      // 清空已添加油卡列表
      this.otherFormData.oilcardList = [];
      // 清空司机各个模式的油
      this.otherFormData.driverOilForPayWay = {};
      // 防止更换车辆后沿用上一车队的字段别名。
      this.otherFormData.selectedVehicleTenantId = '';
    },
    // 获取结算信息，设置 结算 部分的字段
    async queryMemberBenefits (carUserType, isChange) {
      this.$emit('queryMemberBenefits', { carUserType, isChange });
    },
    // 设置缓存和详情返回的数据
    setCacheAndDetailData (data) {
      const selectedVehicle = data.chooseVehicle || {};
      // 编辑/缓存回显也必须先恢复车辆所属租户，再触发订单模式配置查询。
      this.otherFormData.selectedVehicleTenantId = selectedVehicle.tenantId || '';
      this.$refs.baseForm.setVal('chooseVehicle', data.chooseVehicle);
      this.$refs.baseForm.setVal('chooseDriver', data.chooseDriver);
      this.$refs.baseForm.setVal('chooseCopilotDriver', data.chooseCopilotDriver);
      this.$refs.baseForm.setVal('chooseTrailer', data.chooseTrailer);
      this.otherFormData.dispatchTrailerInfo = data.dispatchTrailerInfo;
      if (data.dispatchTrailerInfo && data.dispatchTrailerInfo.trailerId) {
        this.trailerOptions = [data.dispatchTrailerInfo];
      }
      this.otherFormData.sInputOilBalance = data.sInputOilBalance;
      // 油卡上一次充值的金额
      this.otherFormData.sBeforeBalance = data.sBeforeBalance;
      this.otherFormData.oilcardList = data.oilcardList;
      this.setFormItemShowAndHide(data.chooseVehicle);
      this.setVehicleInfoFromCacheAndDetail(data);
      this.expenseTypeList = data.expenseTypeList;
      // 非自有车表单 --- start ---
      this.$refs.baseForm.setVal('isAgent', data.isAgent);
      this.$refs.baseForm.setVal('agentId', data.agentId);
      this.$refs.baseForm.setVal('agentPhone', data.agentPhone);
      this.$refs.baseForm.setVal('agentAccountName', data.agentAccountName);
      this.isAgentChange(data.isAgent);
      this.otherFormData.lineInfo = data.lineInfo;

      this.getFeeParams = {
        vehicleCode: data.chooseVehicle.vehicleCode,
        plateNumber: data.chooseVehicle.plateNumber,
        carDriverId: data.chooseDriver.userId,
        copilotUserId: data.chooseCopilotDriver.userId,
        trailerId: data.dispatchTrailerInfo.trailerId,
        dependTime: this.modeOtherData.dependTimeFromBaseForm,
        lineId: data.lineInfo.lineId,
        arriveTime: data.lineInfo.arriveTime,
        loadEmptyOilCost: data.lineInfo.emptyOilCostPer,
        loadFullOilCost: data.lineInfo.oilCostPer,
        pontagePer: data.lineInfo.pontagePer,
        distance: data.distance,
        nand: data.lineInfo.sourceNand,
        eand: data.lineInfo.sourceEand,
        desEand: data.lineInfo.desEand,
        desNand: data.lineInfo.desNand,
        region: data.lineInfo.sourceCityName,
        provinceId: data.lineInfo.sourceProvince,
        isUpdate: false,
        emptyDistance: data.runWay,
        oilPrice: data.oilPrice,
      };

      // 非自有车表单 --- end ---
      if (this.isSelfOwnedVehicle(data.chooseVehicle)) {
        this.paymentWayChange(data.paymentWay, true);
      }

      this.otherFormData.oilInfo = {
        emptyOilCostPer: data.emptyOilCostPer,
        oilCostPer: data.oilCostPer,
      };

      this.$nextTick(() => {
        if (this.$refs.reimbursement) {
          this.$refs.reimbursement.setCacheAndDetailData(data);
        }
        if (this.$refs.contract) {
          this.$refs.contract.setCacheAndDetailData(data);
        }
        if (this.$refs.orderment) {
          this.$refs.orderment.setCacheAndDetailData(data);
        }
        if (this.$refs.intelligence) {
          this.$refs.intelligence.setFormData({
            emptyOilCostPer: data.lineInfo.emptyOilCostPer / 100,
            oilCostPer: data.lineInfo.oilCostPer / 100,
            pontagePer: data.lineInfo.pontagePer / 100,
            runWay: data.runWay,
          });
          if (this.$refs.intelligence.$refs.intelligenceChart) {
            this.$refs.intelligence.$refs.intelligenceChart.setCacheAndDetailData(data);
          }
        }
      });
      // this.setEditStatus();
    },
    setEditStatus () {
      this.setFormAttrVal({
        form: this.baseForm,
        attr: 'disabled',
        value: !!this.$route.query.id,
        names: ['chooseVehicle', 'chooseTrailer', 'chooseDriver', 'chooseCopilotDriver', 'paymentWay'],
      });
    },
    async handleSubData (cache) {
      let formData = null;
      let reimbursementFormData = null;
      let formDataIntelligence = null;
      let orderFormData = null;
      if (cache) {
        formData = await this.$refs.baseForm.getVal();
        if (formData.paymentWay === '2') {
          reimbursementFormData = await this.$refs.reimbursement.cacheData();
        }
        if (formData.paymentWay === '1') {
          formDataIntelligence = await this.$refs.intelligence.cacheData();
        }
      } else {
        formData = await this.$refs.baseForm.sub();
        if (formData.paymentWay === '2') {
          reimbursementFormData = await this.$refs.reimbursement.sub();
        }
        if (formData.paymentWay === '1') {
          formDataIntelligence = await this.$refs.intelligence.sub();
        }
        if (formData.paymentWay === '4') {
          orderFormData = await this.$refs.orderment.sub();
          if (orderFormData == null) {
            formData = null;
          }

        }
      }
      if (formData || cache) {
        let contractFormData = null;

        if (this.$refs.contract) {
          contractFormData = await this.$refs.contract.sub() || {};
        }
        formData = {
          ...formData,
          ...this.otherFormData,
          ...reimbursementFormData,
          ...contractFormData,
          ...orderFormData,
          ...formDataIntelligence,
        };
      }
      return formData;
    },
    async cacheData () {
      const formData = await this.handleSubData(true);
      return formData;
    },
    async sub () {
      const formData = await this.handleSubData();
      if (formData) {
        formData.agentAvailable = formData.isAgent;
      }
      return formData;
    },
  },
  watch: {
    showComponent: {
      immediate: true,
      handler (newValue, oldValue) {
        this.setFormRuleAttr({
          rules: this.baseForm.rules,
          attr: 'required',
          value: newValue,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.choose-flex {
  display: flex;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
}
</style>
